export default __webpack_public_path__ + "static/media/error.8fc296e5.svg";